import defaultForm from "./default";
import passAndSafetyForm from "./passAndSafety";

export default {
  main_info: defaultForm,
  pass_and_safety: passAndSafetyForm,
};
